import { useDispatch, useSelector } from 'react-redux'
import { ReduxProps } from '@/storage'

import { AdminDataProps } from '@/storage/modules/admin/reducer'
import { useState } from 'react'
import { IoAnalytics, IoLogoFirebase } from 'react-icons/io5'
import { SideMenuProps, handleSetTag } from '@/storage/modules/sideMenu/reducer'

interface AsideProps {
  isError?: boolean
  isOpen: boolean
  isCompactViewport: boolean
  onClose: () => void
}

export function Aside({
  isCompactViewport,
  isError,
  isOpen,
  onClose,
}: AsideProps) {
  const [firebaseIsVisible, setFirebaseIsVisible] = useState(false)

  const dispatch = useDispatch()

  const { admin } = useSelector<ReduxProps, AdminDataProps>(
    (state) => state.admin,
  )

  const { tag } = useSelector<ReduxProps, SideMenuProps>(
    (state) => state.sideMenu,
  )

  const handleNavigate = (nextTag: SideMenuProps['tag']) => {
    dispatch(handleSetTag({ tag: nextTag }))

    if (isCompactViewport) {
      onClose()
    }
  }

  return (
    <aside
      className={`fixed left-0 top-20 z-40 h-[calc(100vh-5rem)] w-[350px] overflow-y-auto bg-gray-700 shadow-2xl transition-transform duration-300 base:w-[320px] md:w-[calc(100vw-1rem)] ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      }`}
    >
      {!isError && admin.id && (
        <>
          <div className="flex flex-col px-10 pt-10 pb-8 base:px-6 md:px-4">
            <button
              className={`text-white font-bold text-lg flex items-center justify-between hover:bg-purple-600 p-2 px-4 rounded-xl transition delay-75 ${
                tag === 'graphics' && `bg-purple-600 text-white`
              } mt-8 transition delay-75`}
              onClick={() => handleNavigate('graphics')}
            >
              Health
              <IoAnalytics />
            </button>

            <button
              className={`text-white font-bold text-lg flex items-center justify-between hover:bg-purple-600 p-2 px-4 rounded-xl transition delay-7 mt-8 ${
                firebaseIsVisible && `bg-purple-600 text-white rounded-b-none`
              }`}
              onClick={() => setFirebaseIsVisible(!firebaseIsVisible)}
            >
              Database
              <IoLogoFirebase />
            </button>
            {firebaseIsVisible && (
              <div className="flex-col flex items-start bg-white rounded-b-xl overflow-hidden">
                <button
                  className={`hover:bg-gray-100 w-full text-left p-2 font-medium pl-4 ${
                    tag === 'artists' && 'bg-gray-100'
                  }`}
                  onClick={() => handleNavigate('artists')}
                >
                  Artists
                </button>

                <button
                  className={`hover:bg-gray-100 w-full text-left p-2 font-medium pl-4 ${
                    tag === 'musics' && 'bg-gray-100'
                  }`}
                  onClick={() => handleNavigate('musics')}
                >
                  Musics
                </button>
                <button
                  className={`hover:bg-gray-100 w-full text-left p-2 font-medium pl-4 ${
                    tag === 'genres' && 'bg-gray-100'
                  }`}
                  onClick={() => handleNavigate('genres')}
                >
                  Musical Genres
                </button>

                <button
                  className={`hover:bg-gray-100 w-full text-left p-2 font-medium pl-4 ${
                    tag === 'scenes' && 'bg-gray-100'
                  }`}
                  onClick={() => handleNavigate('scenes')}
                >
                  Scenes
                </button>

                <button
                  className={`hover:bg-gray-100 w-full text-left p-2 font-medium pl-4 ${
                    tag === 'users' && 'bg-gray-100'
                  }`}
                  onClick={() => handleNavigate('users')}
                >
                  Users
                </button>

                <button
                  className={`hover:bg-gray-100 w-full text-left p-2 font-medium pl-4 ${
                    tag === 'campaigns' && 'bg-gray-100'
                  }`}
                  onClick={() => handleNavigate('campaigns')}
                >
                  Campaigns
                </button>

                <button
                  className={`hover:bg-gray-100 w-full text-left p-2 font-medium pl-4 ${
                    tag === 'events' && 'bg-gray-100'
                  }`}
                  onClick={() => handleNavigate('events')}
                >
                  Eventos
                </button>

                <button
                  className={`hover:bg-gray-100 w-full text-left p-2 font-medium pl-4 ${
                    tag === 'licenses' && 'bg-gray-100'
                  }`}
                  onClick={() => handleNavigate('licenses')}
                >
                  Licenses
                </button>

                <button
                  className={`hover:bg-gray-100 w-full text-left p-2 font-medium pl-4 ${
                    tag === 'moods' && 'bg-gray-100'
                  }`}
                  onClick={() => handleNavigate('moods')}
                >
                  Moods
                </button>

                <button
                  className={`hover:bg-gray-100 w-full text-left p-2 font-medium pl-4 ${
                    tag === 'albums' && 'bg-gray-100'
                  }`}
                  onClick={() => handleNavigate('albums')}
                >
                  Albums
                </button>

                <button
                  className={`hover:bg-gray-100 w-full text-left p-2 font-medium pl-4 ${
                    tag === 'socialMedia' && 'bg-gray-100'
                  }`}
                  onClick={() => handleNavigate('socialMedia')}
                >
                  Social Media
                </button>
              </div>
            )}

            {/* <button
              className={`text-white font-bold text-lg flex items-center justify-between hover:bg-purple-600 p-2 px-4 rounded-xl transition delay-75 ${
                tag === 'notifications' && `bg-purple-600 text-white`
              } mt-8 transition delay-75`}
              onClick={() => dispatch(handleSetTag({ tag: 'notifications' }))}
            >
              Notifications
              <IoNotifications />
            </button> */}
          </div>
        </>
      )}
    </aside>
  )
}
